import { Fragment } from "react";
export default function PaymentSuccess() {
    return (
        <Fragment>
            <div>dd</div>
        </Fragment>
    );
}